import './components/header/index'
import './components/program'

// $('.avatar-ticket .single_add_to_cart_button').appendTo('.yith_wapo_group_total');